import dayjs from "dayjs";
import "dayjs/locale/nl";

import "./global.css";
import "@fontsource/indie-flower";

export const onClientEntry = () => {
  dayjs.locale("nl");
};
